import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LenguageComponent} from './lenguage/lenguage.component';

const routes: Routes = [
    { path: '',
      component: LenguageComponent,
      children: [
        { path: '', redirectTo: 'es', pathMatch: 'full', },
        { path: 'es', loadChildren: '../core/core.module#CoreModule'},
        { path: 'eng', loadChildren: '../core/core.module#CoreModule'},
        { path: 'login', redirectTo: 'es/login', pathMatch: 'full'},
        { path: 'admin', redirectTo: 'es/admin', pathMatch: 'full'},
        { path: '**', redirectTo: 'es/notfound', pathMatch: 'full'}
      ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class LenguageRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/lenguage/lenguage-routing.module.ts